
import { Mapper } from "../../../../base/utils/mapper";
import { TypeMuscleEvaluationPhysiotherapyModel } from "../../../../domain/models/consult/type-muscle-evaluation-physiotherapy.model";
import { TypeMuscleEvaluationPhysiotherapyEntity } from "../entities/type-muscle-evaluation-physiotherapy.entity";
   
export class TypeMuscleEvaluationPhysiotherapyImplementationRepositoryMapper extends Mapper<TypeMuscleEvaluationPhysiotherapyEntity, TypeMuscleEvaluationPhysiotherapyModel>{
            mapFrom(param:  TypeMuscleEvaluationPhysiotherapyEntity):  TypeMuscleEvaluationPhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  TypeMuscleEvaluationPhysiotherapyModel):  TypeMuscleEvaluationPhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }